import { render, staticRenderFns } from "./RequestMapPopupTaskButtons.vue?vue&type=template&id=beec058c&scoped=true&"
import script from "./RequestMapPopupTaskButtons.vue?vue&type=script&lang=js&"
export * from "./RequestMapPopupTaskButtons.vue?vue&type=script&lang=js&"
import style0 from "./RequestMapPopupTaskButtons.vue?vue&type=style&index=0&id=beec058c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beec058c",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
